<template>
  <div class="min-h-screen bg-white text-color-gray-800 font-sans">
    <div class="mx-auto px-4 sm:px-6 lg:px-8 py-10 sm:py-12 lg:grid lg:grid-cols-3 lg:gap-[30px] w-[90%]">
      <!-- Main content -->
      <div class="lg:col-span-2">
        <!-- Header -->
        <header class="mb-10 sm:mb-12 text-center lg:text-left">
          <h1 class="text-size-4xl sm:text-size-5xl font-bold text-color-gray-900">Демо виджет</h1>
          <p class="mt-3 sm:mt-4 text-size-lg sm:text-size-xl text-color-gray-600 max-w-2xl mx-auto lg:mx-0">
            Это демонстрационный виджет для тестирования функциональности
          </p>
        </header>

        <!-- Content Section -->
        <div class="bg-white rounded-2xl p-6 sm:p-8 shadow-xl border border-gray-200/80">
          <div class="space-y-6">
            <div class="bg-gradient-to-br from-blue-50 to-blue-50/50 rounded-2xl p-6 backdrop-blur-sm">
              <h2 class="text-xl font-semibold text-gray-900 mb-4">Демо контент</h2>
              <p class="text-gray-600">
                Здесь может быть размещен любой контент для демонстрации функциональности виджета.
              </p>
            </div>
          </div>
        </div>
      </div>

      <!-- Right side with info panels -->
      <div class="mt-8 lg:mt-0 space-y-6">
        <!-- Info Panel -->
        <div class="lg:sticky lg:top-4">
          <div class="bg-gray-100/80 backdrop-blur-xl rounded-2xl p-6">
            <div class="flex items-center gap-3 mb-4">
              <div class="p-2 bg-blue-50 rounded-lg">
                <svg class="w-5 h-5 text-color-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                </svg>
              </div>
              <h3 class="text-size-lg font-semibold text-color-gray-900">Информация</h3>
            </div>
            <div class="space-y-4 text-size-sm text-color-gray-600">
              <p>
                Это демонстрационный виджет, который показывает базовую структуру и стилизацию компонентов.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Chat Button -->
    <button 
      @click="toggleChat" 
      class="fixed bottom-6 right-6 bg-[#0071e3] hover:bg-[#0077ED] text-white rounded-full p-4 shadow-[0_4px_14px_0_rgba(0,113,227,0.39)] transition-all duration-300 hover:scale-105 hover:shadow-[0_6px_20px_rgba(0,113,227,0.23)] z-[9999]"
    >
      <svg v-if="!isChatOpen" class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z" />
      </svg>
      <svg v-else class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
      </svg>
    </button>

    <!-- Chat Popup -->
    <div 
      v-if="isChatOpen" 
      class="fixed inset-0 sm:inset-auto sm:bottom-24 sm:right-6 w-full sm:w-[480px] h-full sm:h-[700px] transition-all duration-300 transform origin-bottom-right z-[9998]"
      :class="{'animate-slide-up': isChatOpen}"
    >
      <div class="relative h-full">
        <!-- Animated Border -->
        <div class="absolute -inset-[1px] rounded-[21px] sm:rounded-[21px] bg-gradient-to-r from-[#FF69B4] via-[#FFE5B4] to-[#FF69B4] animate-gradient-x"></div>
        
        <!-- Content -->
        <div class="relative bg-[#f5f5f7]/95 backdrop-blur-xl rounded-[20px] sm:rounded-[20px] shadow-[0_8px_30px_rgb(0,0,0,0.12)] h-full flex flex-col">
          <!-- Header -->
          <div class="bg-gradient-to-r from-[#FF69B4]/20 via-[#FFE5B4]/20 to-[#FF69B4]/20 border-b border-gray-100/50 rounded-t-[20px] animate-gradient-x">
            <!-- Main Header -->
            <div class="p-4 sm:p-6">
              <div class="flex items-center justify-between">
                <div class="flex items-center space-x-3 sm:space-x-4">
                  <div class="w-10 h-10 sm:w-12 sm:h-12 rounded-[16px] bg-[#1B3764] flex items-center justify-center shadow-sm">
                    <svg class="w-5 h-5 sm:w-6 sm:h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                    </svg>
                  </div>
                  <div>
                    <h3 class="text-lg sm:text-xl font-semibold text-[#1B3764]">Воронка</h3>
                    <p class="text-xs sm:text-sm text-gray-500 mt-0.5">Чат-бот НИУ ВШЭ</p>
                  </div>
                </div>
                <button @click="toggleChat" class="text-gray-400 hover:text-gray-600 transition-colors">
                  <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>
            </div>
          </div>
          
          <!-- Messages Area -->
          <div class="flex-1 overflow-y-auto p-4 sm:p-6 space-y-4 bg-gradient-to-b from-[#f5f5f7]/50 to-[#f5f5f7]/30">
            <div v-for="(message, index) in messages" :key="index" 
              :class="['flex', message.isBot ? 'justify-start' : 'justify-end']"
            >
              <div 
                :class="[
                  'max-w-[85%] sm:max-w-[80%] rounded-[16px] p-3 sm:p-4 shadow-sm',
                  message.isBot 
                    ? 'bg-white/80 backdrop-blur-sm border border-gray-100/50 text-gray-800' 
                    : 'bg-[#1B3764] text-white'
                ]"
              >
                <p class="text-sm sm:text-[15px] leading-relaxed">{{ message.text }}</p>
                <span class="text-xs mt-1 block opacity-70">
                  {{ message.isBot ? 'Воронка' : 'Вы' }} • {{ message.time }}
                </span>
              </div>
            </div>
          </div>

          <!-- Input Area -->
          <div class="p-3 sm:p-4 border-t border-gray-100/50 bg-[#f5f5f7]/95 backdrop-blur-sm rounded-b-[20px] pb-[calc(env(safe-area-inset-bottom)+12px)] sm:pb-4">
            <div class="flex gap-2">
              <input 
                v-model="newMessage" 
                @keyup.enter="sendMessage"
                type="text" 
                placeholder="Задайте вопрос о поступлении..." 
                class="flex-1 px-3 sm:px-4 py-2 sm:py-3 border border-gray-200/50 rounded-[16px] focus:outline-none focus:ring-2 focus:ring-[#1B3764] focus:border-transparent text-sm sm:text-[15px] placeholder-gray-400 bg-white/80 backdrop-blur-sm"
              >
              <button 
                @click="sendMessage"
                class="px-4 sm:px-6 py-2 sm:py-3 bg-[#1B3764] text-white rounded-[16px] hover:bg-[#2B4C8C] transition-colors font-medium text-sm sm:text-[15px] disabled:opacity-50 disabled:cursor-not-allowed shadow-sm"
                :disabled="!newMessage.trim()"
              >
                Отправить
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import axios from 'axios';

interface Message {
  text: string;
  isBot: boolean;
  time: string;
}

interface ChatCompletionResponse {
  response: string;
}

export default defineComponent({
  name: 'DemoView',

  props: {
    domain: {
      type: String,
      required: true
    },
    storageUri: {
      type: String,
      required: true,
      default: ""
    },
    isApp: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      isLoading: true,
      isChatOpen: false,
      isApiAvailable: false,
      messages: [
        { 
          text: 'Здравствуйте! Я Воронка, виртуальный помощник НИУ ВШЭ. Я помогу вам с вопросами о поступлении, программам обучения и жизни в университете. Что вас интересует?', 
          isBot: true,
          time: '14:00'
        }
      ] as Message[],
      newMessage: '',
      apiHost: 'http://localhost:3036'
    }
  },

  methods: {
    async checkApiAvailability() {
      try {
        const response = await axios.get(`${this.apiHost}/ping`);
        this.isApiAvailable = response.data.available;
      } catch (error) {
        console.error('API availability check failed:', error);
        this.isApiAvailable = false;
      }
    },

    async sendMessage() {
      if (!this.newMessage.trim() || !this.isApiAvailable) return;
      
      const userMessage = this.newMessage;
      this.newMessage = '';
      
      // Add user message
      this.messages.push({
        text: userMessage,
        isBot: false,
        time: this.getCurrentTime()
      });
      
      try {
        // Prepare messages for API
        const apiMessages = this.messages.map(msg => ({
          role: msg.isBot ? 'assistant' : 'user',
          content: msg.text
        }));

        // Send to API
        const response = await axios.post<ChatCompletionResponse>(
          `${this.apiHost}/chat_completion`,
          apiMessages
        );

        // Add bot response
        this.messages.push({
          text: response.data.response,
          isBot: true,
          time: this.getCurrentTime()
        });
      } catch (error) {
        console.error('Failed to get chat completion:', error);
        // Add error message
        this.messages.push({
          text: 'Извините, произошла ошибка при обработке вашего сообщения. Пожалуйста, попробуйте еще раз.',
          isBot: true,
          time: this.getCurrentTime()
        });
      }
    },

    toggleChat() {
      this.isChatOpen = !this.isChatOpen;
      if (this.isChatOpen) {
        this.checkApiAvailability();
      }
    },
    
    getCurrentTime() {
      const now = new Date();
      return now.getHours().toString().padStart(2, '0') + ':' + 
             now.getMinutes().toString().padStart(2, '0');
    }
  },

  mounted() {
    console.log('DemoView mounted');
    this.isLoading = false;
    this.checkApiAvailability();
  }
});
</script>

<style scoped>
/* Reuse existing styles from other views */
.text-size-lg {
  font-size: 1.5rem !important;
  line-height: 1.4 !important;
  letter-spacing: -0.02em !important;
}

.text-size-xl {
  font-size: 1.75rem !important;
  line-height: 1.3 !important;
  letter-spacing: -0.02em !important;
}

.text-size-4xl {
  font-size: 3rem !important;
  line-height: 1.1 !important;
  letter-spacing: -0.03em !important;
}

.text-size-5xl {
  font-size: 3.5rem !important;
  line-height: 1.1 !important;
  letter-spacing: -0.03em !important;
}

.text-color-gray-600 {
  color: rgb(75 85 99);
}

.text-color-gray-900 {
  color: rgb(17 24 39);
}

.text-color-blue-600 {
  color: rgb(37 99 235);
}

@keyframes gradient-x {
  0% {
    background-position: 0% 50%;
  }
  25% {
    background-position: 50% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  75% {
    background-position: 50% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

.animate-gradient-x {
  animation: gradient-x 4s ease-in-out infinite;
  background-size: 300% 100%;
}

@keyframes slide-up {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.animate-slide-up {
  animation: slide-up 0.3s ease-out;
}
</style> 